export class Faq {
  constructor({
    ativo = null,
    id = null,
    palavrasChave = Array(),
    pergunta = null,
    posicao = null,
    resposta = null,
  }) {
    this.ativo = ativo;
    this.id = id;
    this.palavrasChave = palavrasChave;
    this.pergunta = pergunta;
    this.posicao = posicao;
    this.resposta = resposta;
  }
  static Build() {
    return new Faq({
      ativo: null,
      id: null,
      palavrasChave: Array(),
      pergunta: null,
      posicao: null,
      resposta: null,
    });
  }
  format() {
    return this;
  }
}
